import React from 'react';

export function AppHeader({ title, subtitle, right }) {
  return (
    <header className="page-header">
      <div className="row">
        <div>
          <h2 className="page-title">{title}</h2>
          {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
        </div>
        {right ? <div style={{ marginLeft: 'auto' }}>{right}</div> : null}
      </div>
    </header>
  );
}

export function StatCard({ label, value }) {
  return (
    <article className="card">
      <p className="stat-card-label">{label}</p>
      <p className="stat-card-value">{value}</p>
    </article>
  );
}

export function SectionCard({ title, children, className = '' }) {
  return (
    <section className={`card ${className}`.trim()}>
      {title ? <h3 className="section-title">{title}</h3> : null}
      {children}
    </section>
  );
}

export function StatusBanner({ kind = 'success', message }) {
  if (!message) return null;
  const classNameByKind = {
    success: 'status-success',
    error: 'status-error',
    warning: 'status-warning'
  };
  const statusClass = classNameByKind[kind] || classNameByKind.success;
  return <div className={`status-banner ${statusClass}`}>{message}</div>;
}

export function EmptyState({ message }) {
  return <p className="muted">{message || 'No data available.'}</p>;
}

export function LoadingState({ message }) {
  return (
    <SectionCard>
      <p className="muted">{message || 'Loading...'}</p>
    </SectionCard>
  );
}
